// extracted by mini-css-extract-plugin
export var arrows = "_2f-5";
export var decrementer = "_2f-9";
export var disabled = "_2f-3";
export var error = "_2f-1";
export var hiddenText = "_2f-a";
export var incrementer = "_2f-8";
export var input = "_2f-7";
export var inputWrapper = "_2f-0";
export var leadingIcon = "_2f-b";
export var readonly = "_2f-2";
export var regular = "_2f-6";
export var small = "_2f-4";